import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { addFilesOpen, getAll } from "../../../actions";
import { classesStatus, formatExpedienteDate, status } from "../../../utils";
import PerfectScrollbar from "react-perfect-scrollbar";

class SearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      isSearching: false,
      timer: null,
      checkedBox: [false, false, false],
    };
    this.containerRef = React.createRef();
    this.formRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleOpenFileFromSearch = this.handleOpenFileFromSearch.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    clearTimeout(this.state.timer);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allsearch !== this.props.allsearch) {
      this.setState({ isSearching: false });
    }
  }

  handleClickOutside(event) {
    if (
      this.containerRef.current &&
      !this.containerRef.current.contains(event.target)
    ) {
      this.props.getAll("");
      this.setState({ searchValue: "", isSearching: false });
      if (this.formRef.current) this.formRef.current.reset();
    }
  }

  handleOpenFileFromSearch(file) {
    const { addFilesOpen, getAll } = this.props;
    if (file?.is_open) {
      addFilesOpen({ id: file.id, number: file.number });
    }
    getAll("");
    this.setState({ searchValue: "", isSearching: false });
    if (this.formRef.current) this.formRef.current.reset();
  }

  handlePersonClick() {
    this.props.getAll("");
    this.setState({ searchValue: "", isSearching: false });
    if (this.formRef.current) this.formRef.current.reset();
  }

  handleInputChange(e) {
    const query = e.target.value;
    clearTimeout(this.state.timer);
    this.setState({ searchValue: query });

    if (!query.trim()) {
      this.props.getAll("");
      this.setState({ isSearching: false, timer: null });
      return;
    }

    this.setState({ isSearching: true });
    const newTimer = setTimeout(() => {
      this.props.getAll(query);
    }, 500);
    this.setState({ timer: newTimer });
  }

  render() {
    const { allsearch } = this.props;
    const { searchValue, isSearching } = this.state;

    const showPanel = searchValue.trim().length > 0;
    const hasResults =
      allsearch &&
      ((allsearch.files && allsearch.files.length > 0) ||
        (allsearch.people && allsearch.people.length > 0));
    const hasNoResults =
      !isSearching &&
      allsearch &&
      allsearch.files &&
      allsearch.files.length === 0 &&
      allsearch.people &&
      allsearch.people.length === 0;

    const panelStyle = {
      background: "white",
      borderRadius: "10px",
      border: "1px solid black",
    };

    return (
      <div className="navbar-form" ref={this.containerRef}>
        <form
          action=""
          method="POST"
          name="search_form"
          id="formSearch"
          ref={this.formRef}
        >
          <div className="form-group position-relative">
            <button className="btn btn-search" disabled={true}>
              <i className="fa fa-search me-20px icon-search-action"></i>
            </button>
            <input
              type="text"
              className="form-control d-flex d-sm-flex"
              onChange={this.handleInputChange}
              placeholder="Busca expedientes, personas, etc ..."
            />

            {showPanel && isSearching && (
              <div className="position-absolute w-100 mt-1">
                <div
                  style={{
                    ...panelStyle,
                    padding: "14px 20px",
                    textAlign: "center",
                    color: "#6c757d",
                  }}
                >
                  <i className="fas fa-circle-notch fa-spin me-2"></i>
                  Buscando...
                </div>
              </div>
            )}

            {showPanel && !isSearching && hasResults && (
              <div className="position-absolute w-100 mt-1">
                <PerfectScrollbar
                  style={{
                    ...panelStyle,
                    alignContent: "space-between",
                    paddingTop: "10px",
                    overflowY: "auto",
                    maxHeight: "60vmin",
                  }}
                >
                  <span
                    className="mx-4 d-flex fw-bold"
                    style={{ justifyContent: "right" }}
                  >
                    {allsearch.files.length + allsearch.people.length}{" "}
                    resultados encontrados
                  </span>
                  <br />
                  {allsearch.files.map((file) => (
                    <div
                      className="d-flex w-100 p-3 textDecorationNone alternColorSearch"
                      key={file.id}
                    >
                      <span className="m-auto" style={{ color: "gray" }}>
                        <i className="fas fa-lg fa-fw me-10px fa-folder-open"></i>
                      </span>
                      <span
                        className="w-50 fw-bold"
                        style={{ marginLeft: "0", marginRight: "auto" }}
                      >
                        <div>
                          Expediente # {file["number"]}
                          <span className="ms-1 fs-10px text-gray-500">
                            ({formatExpedienteDate(file?.open_date)})
                          </span>
                        </div>
                        <div className="fw-400">
                          Cliente: {file?.customer?.full_name || "-"}
                        </div>
                        <div className="fw-400">
                          Consulta: {file?.reason || "-"}
                        </div>
                        <span
                          className="fw-400 m-auto"
                          style={{
                            fontStyle: "italic",
                            margin: "auto",
                            textDecoration: "none",
                            color: "var(--bs-body-color)",
                          }}
                        >
                          <span className={classesStatus(file.status)}>
                            <i className="fa fa-circle fs-9px fa-fw me-5px"></i>
                            {status(file.status)}
                          </span>
                          <br />
                        </span>
                      </span>
                      <div className="m-auto d-flex" style={{ color: "gray" }}>
                        <Link
                          to={
                            file?.is_open
                              ? `/Expediente/${file.id}`
                              : `/ExpedienteArchivado/${file.id}`
                          }
                          onClick={() => this.handleOpenFileFromSearch(file)}
                          title="Ver"
                          className="btn btn-sm btn-green me-1 p-auto"
                        >
                          <i className="fab fa-lg fa-fw fs-14px fa-sistrix text-white"></i>
                        </Link>
                      </div>
                    </div>
                  ))}

                  {allsearch.people &&
                    allsearch.people.length > 0 &&
                    allsearch.people.map((person) => (
                      <div
                        className="d-flex w-100 p-3 textDecorationNone alternColorSearch"
                        key={person.id}
                      >
                        <span className="m-auto" style={{ color: "gray" }}>
                          <i className="fas fa-lg fa-fw me-10px fa-user"></i>
                        </span>
                        <span
                          className="w-50 fw-bold"
                          style={{ marginLeft: "0", marginRight: "auto" }}
                        >
                          {person.full_name}
                          <br />
                          <span
                            className="fw-400"
                            style={{
                              fontStyle: "italic",
                              color: "var(--bs-body-color)",
                            }}
                          >
                            {person.is_customer
                              ? "Cliente"
                              : person.is_freelance
                              ? "Freelancer"
                              : "Empleado"}
                          </span>
                        </span>
                        <div className="m-auto" style={{ color: "gray" }}>
                          <Link
                            to={
                              person.is_customer
                                ? `/Persona/${person.id}`
                                : person.is_freelance
                                ? `/Freelancer/${person.id}`
                                : `/Staffs/${person.id}`
                            }
                            onClick={() => this.handlePersonClick()}
                            title="Ver"
                            className="btn btn-sm btn-green me-1 p-auto"
                          >
                            <i className="fab fa-lg fa-fw fs-14px fa-sistrix text-white"></i>
                          </Link>
                        </div>
                      </div>
                    ))}
                </PerfectScrollbar>
              </div>
            )}

            {showPanel && hasNoResults && (
              <div className="position-absolute w-100 mt-1">
                <div
                  style={{
                    ...panelStyle,
                    padding: "14px 20px",
                    textAlign: "center",
                    color: "#6c757d",
                  }}
                >
                  <i className="fa fa-search me-2 opacity-50"></i>
                  No se encontraron resultados
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  personsSearch: state.counterSlice.personsSearch,
  filesSearch: state.counterSlice.filesSearch,
  allsearch: state.counterSlice.allsearch,
});
const mapDispatchToProps = {
  getAll,
  addFilesOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);
